import React, { MouseEventHandler } from 'react'
import ProductSnippet from '../../blocks/ProductSnippet/ProductSnippet'
import styles from './Main.module.css'
import { useCart } from '../../../contexts/CartContext'

const categories = [
  {
    id: 'vodka',
    name: 'Водка',
  },
  {
    id: 'konyak',
    name: 'Коньяк',
  },
  {
    id: 'rom',
    name: 'Ром',
  },
  {
    id: 'viski',
    name: 'Виски',
  },
  {
    id: 'vino',
    name: 'Вино',
  },
  {
    id: 'shampanskoe',
    name: 'Шампанское',
  },
  {
    id: 'vermut',
    name: 'Вермут',
  },
  {
    id: 'liker',
    name: 'Ликeры',
  },
  {
    id: 'dzhin',
    name: 'Джин',
  },
  {
    id: 'tekila',
    name: 'Текила',
  },
  {
    id: 'pivo',
    name: 'Пиво',
  },
  {
    id: 'bezalko',
    name: 'Безалкогольные напитки',
  },
  {
    id: 'sneki',
    name: 'Снеки',
  },
  {
    id: 'sigarety',
    name: 'Сигареты',
  },
  {
    id: 'nuzhnoe',
    name: 'Нужное',
  },
]

const Main = () => {
  const { products } = useCart()

  if (!products) {
    return null
  }

  return (
    <div className={styles.main}>
      <div className={styles.categories}>
        {categories.map((category) => {
          const handleAnchorClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
            event.preventDefault()
            window.scroll({
              top: window.scrollY + document.getElementById(category.id)!.getBoundingClientRect().top - 126,
              behavior: 'smooth',
            })
          }

          return (
            <a href={`#${category.id}`} key={category.id} onClick={handleAnchorClick}>
              {category.name}
            </a>
          )
        })}
      </div>
      <div className={styles.about}>
        <p>Алкомиг 96</p>
        <p>Алкоголь 24/7 в Екатеринбурге.</p>
        <p>
          Принимаем заказы круглосуточно в этом боте, через сайт{' '}
          <a href="https://alcomig96.com" target="_blank" rel="noopener noreferrer">
            alcomig96.com
          </a>{' '}
          или по телефону:{' '}
          <button
            type="button"
            className={styles.buttonLink}
            onClick={(event) => {
              window.open('tel:+73433190519')
            }}
          >
            +7 (343) 319-05-19
          </button>
        </p>
      </div>

      {categories.map((category) => {
        return (
          <div key={category.id} className={styles.category}>
            <h2 id={category.id}>{category.name}</h2>
            <div className={styles.products}>
              {products
                .filter((product) => {
                  return product.category === category.id
                })
                .map((product) => {
                  return (
                    <div key={product.id} className={styles.product}>
                      <ProductSnippet product={product} />
                    </div>
                  )
                })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Main
